import i18n from "@/i18n";

// MBR125: screens used to hand the raw axios error (or a validation MessageBag) to the
// snackbar, which showed "AxiosError: Request failed with status code 422", a JSON blob
// or "[object Object]". This turns whatever a request failed with into one readable line.

const t = (key) => i18n.global.t(key);

// First non-empty string inside a string / array / Laravel MessageBag ({ field: [msg] }).
function firstText(value) {
  if (typeof value === "string") {
    return value.trim();
  }
  if (value && typeof value === "object") {
    for (const item of Object.values(value)) {
      const text = firstText(item);
      if (text) {
        return text;
      }
    }
  }

  return "";
}

// Message carried by an API body: { result: { message } } (ApiResponseTrait), then
// Laravel's own { errors } / { message } — the latter only below 500, where it is
// meant for users (a 500's message can be a raw exception on a debug server).
function bodyText(data, status) {
  if (!data || typeof data !== "object") {
    return "";
  }

  return (
    firstText(data.result?.message) ||
    firstText(data.errors) ||
    (status < 500 ? firstText(data.message) : "")
  );
}

export function errorMessage(error, fallbackKey = "common.generic_error") {
  let text = "";

  if (typeof error === "string") {
    text = error.trim();
  } else if (error?.response) {
    // the server answered with an error status
    text = bodyText(error.response.data, error.response.status);
  } else if (error?.isAxiosError || error?.request) {
    // no answer at all: offline, DNS, CORS, timeout
    return t("common.network_error");
  } else if (error && typeof error === "object" && !(error instanceof Error)) {
    // an API body passed on as-is ({ result: { message } }) or a bare MessageBag
    text = bodyText(error, 0) || firstText(error);
  }

  return text || t(fallbackKey);
}
